import { Shop, ShopFromApi } from '../types/shops';
import trackError from './trackError';

const API_DEFAULT_LIMIT = 100;
let shops: Shop[] = [];

export const fetchShops = async (): Promise<Shop[]> => {
  try {
    const shopApiUrl = 'API/Account/{{systemCustomerID}}/Shop.json';
    const remainingShopsPromiseArray = [];
    const response = await window.merchantos.session.apiRequest(shopApiUrl);
    const totalShops = parseInt(response['@attributes'].count, 10);
    const requestsLeft = Math.ceil(totalShops / API_DEFAULT_LIMIT);
    let shopsArray: ShopFromApi[] = [];
    // Single entity is an object; multiple entities are an array
    shopsArray = shopsArray.concat(response.Shop);

    for (let i = 1; i < requestsLeft; i += 1) {
      remainingShopsPromiseArray.push(
        window.merchantos.session.apiRequest(`${shopApiUrl}?offset=${API_DEFAULT_LIMIT * i}`)
      );
    }

    const remainingShops = await Promise.all(remainingShopsPromiseArray);
    shopsArray = shopsArray.concat(remainingShops.map((item) => item.Shop).flat());

    shops = shopsArray
      .filter((shop: ShopFromApi) => shop.archived === 'false')
      .map(
        (shop: ShopFromApi): Shop => ({
          hasAccess: false,
          id: parseInt(shop.shopID, 10),
          isDefault: false,
          name: shop.name,
        })
      );
    return shops;
  } catch (error) {
    trackError({ description: 'fetchShops failed', error });
    return [];
  }
};
